import React from 'react';
import BaseModal from './BaseModal';

interface LoadingModalProps {
  isOpen: boolean;
  message?: string;
  subMessage?: string;
}

export const LoadingModal: React.FC<LoadingModalProps> = ({
  isOpen,
  message = "Loading...",
  subMessage
}) => {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={() => {}} // Loading modal shouldn't be closeable
      size="sm"
      showCloseButton={false}
      closeOnBackdropClick={false}
    >
      <div className="text-center">
        {/* Spinner */}
        <div className="mb-4 flex justify-center">
          <div className="animate-spin h-12 w-12 border-4 border-blue-500 border-t-transparent rounded-full" />
        </div>

        {/* Message */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {message}
        </h3>

        {/* Sub-message */}
        {subMessage && (
          <p className="text-sm text-gray-500">
            {subMessage}
          </p>
        )}
      </div>
    </BaseModal>
  );
};